import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { I18nProvider } from './i18n';
import { registerServiceWorker, setupInstallPrompt } from './utils/pwa';
import './index.css';

/**
 * NoTomorrow3D Frontend Entry Point
 * 
 * "Every great FOMO journey begins with a single render."
 */

// Register service worker for PWA
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  registerServiceWorker().then((registration) => {
    if (registration) {
      console.log('[NT3D] Service worker registered');
    }
  });
}

// Setup install prompt
setupInstallPrompt((canInstall) => {
  if (canInstall) {
    console.log('[NT3D] App can be installed');
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </React.StrictMode>,
);
